import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Garage.css';

const ORDRE_JOURS = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

function formatHeure(h) {
  if (!h) return '—';
  return h.slice(0, 5);
}

function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('fr-FR');
}

function Garage() {
  const [horaires, setHoraires] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vacances, setVacances] = useState(null);

  useEffect(() => {
    axios.get('/api/horaires/')
      .then(res => {
        const sorted = res.data.sort(
          (a, b) => ORDRE_JOURS.indexOf(a.jour) - ORDRE_JOURS.indexOf(b.jour)
        );
        setHoraires(sorted);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
    axios.get('/api/vacances/')
      .then(res => setVacances(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="garage-page">

      <div className="page-header container">
        <p className="garage-eyebrow">Qui sommes-nous</p>
        <h1 className="section-title">Garage <span>Eagle Car's</span></h1>
        <div className="gold-line centered" />
        <p className="section-subtitle">
          Votre garage toutes marques — achat, vente, mécanique, carrosserie et dépannage 7j/7.
        </p>
      </div>

      <div className="container garage-body">

        {/* Histoire */}
        <div className="garage-histoire">
          <div className="histoire-text">
            <h2 className="section-title">Notre <span>Garage</span></h2>
            <div className="gold-line" />
            <p>
              Le Garage Eagle Car's est votre spécialiste automobile toutes marques.
              Que vous cherchiez à acheter ou vendre un véhicule d'occasion, à faire
              entretenir votre voiture, ou à louer un véhicule, nous sommes là pour vous.
            </p>
            <p>
              Notre équipe qualifiée intervient en mécanique, carrosserie et dépannage
              7 jours sur 7, avec professionnalisme et transparence.
            </p>
          </div>
          <div className="histoire-accent">
            <div className="accent-card">
              <span>7/7</span>
              <p>Dépannage disponible</p>
            </div>
            <div className="accent-card">
              <span>∞</span>
              <p>Toutes marques</p>
            </div>
          </div>
        </div>

        {/* Horaires */}
        <div className="garage-horaires">
          <div className="section-header centered">
            <h2 className="section-title">Nos <span>Horaires</span></h2>
            <div className="gold-line centered" />
          </div>

          {vacances?.en_vacances && (
            <div className="vacances-banner">
              Nous sommes en vacances du {formatDate(vacances.vacances_debut)} au {formatDate(vacances.vacances_fin)}
            </div>
          )}

          {loading ? (
            <p className="loading-text">Chargement...</p>
          ) : horaires.length === 0 ? (
            <p className="loading-text">Horaires à venir.</p>
          ) : (
            <div className="horaires-table">
              {horaires.map(h => (
                <div className={`horaire-row ${h.ferme ? 'ferme' : ''}`} key={h.id}>
                  <span className="jour">{h.jour.charAt(0).toUpperCase() + h.jour.slice(1)}</span>
                  {h.ferme ? (
                    <span className="ferme-label">Fermé</span>
                  ) : (
                    <div className="horaire-heures">
                      <span>{formatHeure(h.ouverture_matin)} – {formatHeure(h.fermeture_matin)}</span>
                      <span className="separator">·</span>
                      <span>{formatHeure(h.ouverture_apres_midi)} – {formatHeure(h.fermeture_apres_midi)}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Contact */}
        <div className="garage-contact">
          <div className="contact-card">
            <h3>Téléphone</h3>
            <a href="tel:+33676798771">06 76 79 87 71</a>
            <a href="tel:+33450795733">04 50 79 57 33</a>
          </div>
          <div className="contact-card">
            <h3>Email</h3>
            <a href="mailto:garage.eagle.cars@gmail.com">garage.eagle.cars@gmail.com</a>
          </div>
          <div className="contact-card">
            <h3>Dépannage</h3>
            <p>7 jours sur 7<br />Intervention rapide</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Garage;
